import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarCidadesEstadosService } from "../../../services/buscarCidadesEstadosService";
import { buscarEmpreendimentosService } from "../../../services/buscarEmpreendimentosService";
import { buscarInteresseByIdService } from "../../../services/buscarInteresseByIdService";
import { buscarNaoInteresseEmpreendimentoService } from "../../../services/buscarNaoInteresseEmpreendimentoService";
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { Interesses } from "../../../interfaces/Interesses";
import { buscarEmpreendimentosComCidadeService } from "../../../services/buscarEmpreendimentosComCidadeService";

// seu hook
export const useInteresses = (method: number, interesseId: number) => {
  const [interesseSelecionado, setInteresseSelecionado] =
    useState<Partial<Interesses>>();
  const [empreendsSelecionados, setEmpreendsSelecionados] = useState<any[]>([]);
  const [empreendsCidades, setEmpreendsCidades] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = async () => {
    try {
      const dataEmpreendimentosCidadesEstados =
        await buscarEmpreendimentosComCidadeService();

      const empreendimentosCidades = formatarEmpreendimentosCidades(
        dataEmpreendimentosCidadesEstados
      );

      setEmpreendsCidades(empreendimentosCidades);

      if (method === 1) {
        // 3. Buscar interesses e não-interesses
        const dataInteresse = await buscarInteresseByIdService(interesseId);
        setInteresseSelecionado(dataInteresse);

        const dataEmpreendsInteresse =
          await buscarNaoInteresseEmpreendimentoService(interesseId);
        setEmpreendsSelecionados(dataEmpreendsInteresse);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return {
    empreendsSelecionados,
    interesseSelecionado,
    empreendsCidades,
    isLoading,
  };
};

const formatarEmpreendimentosCidades = (empreendimentosCidades: any[]) => {
  return empreendimentosCidades.map((ec) => {
    return {
      id: ec.id,
      nome: ec.nome,
      cidadeId: ec.CidadeTable.id,
      nomeCidade: ec.CidadeTable.nome,
      abreviacaoCidade: ec.CidadeTable.abreviacao || "",
      cronograma: ec.cronograma || "",
    };
  });
};
